import { useState } from 'react';
import ChildrensTooltip from '@/components/common/ChildrensTooltip';
import { Button } from 'react-bootstrap';
import {
  AiOutlineFileText,
  AiOutlineFolder,
  AiOutlineTag
} from 'react-icons/ai';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MoveToGroupForSelectedRows from '@/app/KeywordTracker/components/keywords/drawers/MoveToGroupForSelectedRows';
import MoveToTagsForSelectedRows from '@/app/KeywordTracker/components/keywords/drawers/MoveToTagsForSelectedRows';
import MoveToLandingForSelectedRows from '@/app/KeywordTracker/components/keywords/drawers/MoveToLandingForSelectedRows';
import useDomain from '@/hooks/useDomain';
import { useDispatch, useSelector } from 'react-redux';
import DeleteKeywords from './DeleteKeywords';
import { showModal } from '@/app/common/reducers/simpleModal';
import { useGetTariffInfoQuery } from '../../api/keywordsApi';

const GridActionButtons = ({ gridRef, setShouldRevalidateFirstPage }) => {
  const { domain_slug } = useDomain();
  const selectedKeys = useSelector(state => state.selectedKeys);
  const dispatch = useDispatch();
  const [showAddGroupModal, setshowAddGroupModal] = useState(false);
  const [showAddTagsModal, setshowAddTagsModal] = useState(false);
  const [showAddLandingModal, setShowAddLandingModal] = useState(false);
  const { data: trackerInfo, isFetching: isFetchingTrackerInfo } =
    useGetTariffInfoQuery(domain_slug);
  const isAccessAllowed = () =>
    trackerInfo?.data?.access_level !== 3 && !isFetchingTrackerInfo;

  return (
    <div className="d-flex gap-2 align-items-center">
      {selectedKeys.length > 0 && (
        <>
          <ChildrensTooltip
            delayToRemove={0}
            placement="top"
            html={
              isAccessAllowed() ? 'مدیریت دسته' : 'شما دسترسی لازم را ندارید'
            }
          >
            <Button
              style={{
                height: 30,
                padding: 8
              }}
              disabled={!isAccessAllowed()}
              onClick={() => setshowAddGroupModal(true)}
              variant="falcon-primary"
              size="sm"
              className="d-flex gap-1 align-items-center"
            >
              <AiOutlineFolder className="fs-1" />{' '}
            </Button>
          </ChildrensTooltip>

          <ChildrensTooltip
            delayToRemove={0}
            placement="top"
            html={
              isAccessAllowed() ? 'مدیریت برچسب' : 'شما دسترسی لازم را ندارید.'
            }
          >
            <Button
              style={{
                height: 30,
                padding: 8
              }}
              disabled={!isAccessAllowed()}
              onClick={() => setshowAddTagsModal(true)}
              variant="falcon-primary"
              size="sm"
              className="d-flex gap-2 align-items-center"
            >
              <AiOutlineTag className="fs-1" />{' '}
            </Button>
          </ChildrensTooltip>
          <ChildrensTooltip
            delayToRemove={0}
            placement="top"
            html={
              isAccessAllowed()
                ? 'مدیریت صفحه هدف'
                : 'شما دسترسی لازم را ندارید'
            }
          >
            <Button
              style={{
                height: 30,
                padding: 8
              }}
              disabled={!isAccessAllowed()}
              onClick={() => setShowAddLandingModal(true)}
              variant="falcon-primary"
              size="sm"
              className="d-flex gap-2 align-items-center"
            >
              <AiOutlineFileText className="fs-1" />{' '}
            </Button>
          </ChildrensTooltip>
          <ChildrensTooltip
            delayToRemove={0}
            placement="top"
            html={isAccessAllowed() ? 'حذف کلمه' : 'شما دسترسی لازم را ندارید'}
          >
            <Button
              style={{
                height: 30,
                padding: 12
              }}
              disabled={!isAccessAllowed()}
              onClick={() => dispatch(showModal('DELETE_KEYWORD'))}
              variant="danger"
              size="sm"
              className="d-flex gap-2 align-items-center"
            >
              <FontAwesomeIcon icon="trash-alt" className="fs-0" />
            </Button>
          </ChildrensTooltip>
        </>
      )}
      <MoveToGroupForSelectedRows
        show={showAddGroupModal}
        setShow={setshowAddGroupModal}
        gridRef={gridRef}
      />
      <MoveToTagsForSelectedRows
        show={showAddTagsModal}
        setShow={setshowAddTagsModal}
        gridRef={gridRef}
      />

      <MoveToLandingForSelectedRows
        show={showAddLandingModal}
        setShow={setShowAddLandingModal}
        gridRef={gridRef}
      />
      <DeleteKeywords
        setShouldRevalidateFirstPage={setShouldRevalidateFirstPage}
        gridRef={gridRef}
      />
    </div>
  );
};

export default GridActionButtons;
